import { routes } from '@/routes'
import { useLocales } from '@sevenrooms/locales'
import { Switch, Route } from '@sevenrooms/navigation'
import { ReservationStatus, PriorityAlert, BookReservation, ManageReservationContainer, WidgetContainer } from '../../components'
import { useVenue } from '../../hooks'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'

export function Alerts() {
  const { formatMessage } = useLocales()
  const { largeLogoUrl, urlKey, name } = useVenue()
  const venueLink = `/reservations/${urlKey}`

  return (
    <WidgetContainer largeLogoUrl={largeLogoUrl} venueLink={venueLink} venueName={name} enableGrowingTopNav={false}>
      <ManageReservationContainer>
        <Switch>
          <Route path={routes.reservations.alerts.canceled.path}>
            <ReservationStatus header={formatMessage(reservationWidgetMessages.resCancelPageCancelPriorityAlertsSuccessHeader)}>
              <BookReservation />
            </ReservationStatus>
          </Route>
          <Route path={routes.reservations.alerts.path}>
            <ReservationStatus header={formatMessage(reservationWidgetMessages.resCancelPageCancelPriorityAlertsHeader)}>
              <PriorityAlert />
            </ReservationStatus>
          </Route>
        </Switch>
      </ManageReservationContainer>
    </WidgetContainer>
  )
}
